<template>
    <div class="mobile-container">
        <div class="main-content">
            <router-view></router-view>
        </div>
        <van-tabbar v-model="active" @change="onChange" safe-area-inset-bottom class="layout-tabbar">
            <van-tabbar-item name="/Contract" icon="completed-o">合同信息</van-tabbar-item>
            <van-tabbar-item name="/routes" icon="home-o">主菜单</van-tabbar-item>
            <van-tabbar-item name="/userInfo" icon="contact">个人信息</van-tabbar-item>
        </van-tabbar>
        <displays-logs v-if="showLogs" :show-dialog="showLogs"></displays-logs>
    </div>
</template>

<script>
import LeftNav from "@/components/LeftNav";
import Header from "@/components/Header";
import { copyText } from "@/utils/windowsUtils";
import HeaderBread from "@/components/HeaderBread";
import { getDataInLocalStorage } from "@/utils/localStorage";
import DisplaysLogs from "@/components/logs/DisplaysLogs";
const otherApiUrl = process.env.VUE_APP_OTHER_API
export default {
    name: "HomeM",
    components: { DisplaysLogs, HeaderBread, Header, LeftNav },
    data() {
        return {
            showLogs: false,
            active: this.$route.path
        }
    },
    watch: {
        '$route'(newRoute) {
            this.active = newRoute.path
        },
    },
    mounted() {
        var userAgent = navigator.userAgent.toLowerCase();//判断是否在微信中打开
        if (userAgent.indexOf('micromessenger') !== -1) {
            this.$dialog.confirm({
                title: '用微信内置的浏览器打开网页可能会出现样式错位，影响操作效果。建议用其他浏览器打开。',
                message: '提示',
                confirmButtonText: '点击复制网页地址',
            }).then(() => {
                copyText(window.location.href)
            }).catch(() => {

            });
            
        }
        // 获取用户对新日志读取状态
        fetch(`${otherApiUrl}/person_api/version-log-read/status?uuid=${getDataInLocalStorage('uuid')}&space=bs`, {
            method: 'get',
        }).then(res => res.json()).then(res1 => {
            if (res1.code !== 200) {
                this.$messageUi.error(res1.msg)
            }
            else {
                if (!res1.data) this.showLogs = true
            }
        }).catch(err => { })
    },
    computed: { 
        currentNav() {
            return this.$route.name.split('/')
        }
    },
    methods: {
        onChange(active) {
            this.$router.push({ path: active })
        },
    }
}
</script>

<style scoped>
.mobile-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f7f8fa;
}

.main-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 50px;
    -webkit-overflow-scrolling: touch;
}

.layout-tabbar {
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
}

.van-tabbar-item {
    color: #646566;
}

.van-tabbar-item--active {
    color: #1989fa;
}

</style>
